// Custom Dropdown with searchable field
// input-> data: Array to show in dropdown , name: for placeholder,  value : value displayed in the field , handler
import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

export default function CustomDropdown(props) {
  const changeHandler = (value) => {
    if (value) {
      props.changeHandler(value);
    }
  };
  return (
    <Autocomplete
      options={
        props?.data === "Error fetching data" || !props?.data ? [] : props.data
      }
      getOptionLabel={(option) => {
        return props?.labelFieldName
          ? option?.[props?.labelFieldName]
          : props.name === "Partner Name"
          ? option.partnerName || ""
          : option || "";
      }}
      disableClearable
      size="small"
      loading={props?.loading}
      {...(typeof props.getOptionDisabled === "function"
        ? { getOptionDisabled: props.getOptionDisabled }
        : {})}
      noOptionsText={
        props.data === "Error fetching data"
          ? "Error fetching data"
          : "No data available"
      }
      value={props && props.value ? props.value : null}
      onChange={(event, value) => changeHandler(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.name}
          variant="outlined"
          fullWidth
        />
      )}
      slotprops={{
        popper: {
          sx: {
            zIndex: 50,
          },
        },
      }}
    />
  );
}
